/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsNumeric } from '../../factoriesAny.js';
export var isNumericDependencies = {
  typedDependencies: typedDependencies,
  createIsNumeric: createIsNumeric
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsNumeric.generated.js
// module id = 133
// module chunks = 0